import type { Menu } from '@/models/menu'
import { map } from 'nanostores'

export const $menus = map<Record<string, Menu>>()
export const $promises = map<Record<string, Promise<any> | undefined>>()

export const loggables = {
  'menu/$menus': $menus,
  // 'menu/$promises': $promises,
}
